// Hooks / Node modules / Styles
import { Form, Input, Button } from "elseware-ui";
import * as Yup from "yup";
import { FaGoogle, FaLinkedin } from "react-icons/fa";

// Reducers / Actions

// Utils / Functions

// Components
import DefaultLayout from "src/layout/standard/primary/DefaultLayout";

// Sub-Components

// Authentication Handlers (Replace with actual implementations)
const handleGoogleSignup = () => {
  console.log("Google Signup Clicked");
  // Implement Google OAuth signup logic
};

const handleLinkedInSignup = () => {
  console.log("LinkedIn Signup Clicked");
  // Implement LinkedIn OAuth signup logic
};

// Data / Images / Icons
const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  confirmPassword: "",
};

const validations = Yup.object({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm Password is required"),
});

const onSubmit = (values) => {
  console.log("Signup Form Submitted:", values);
  // Implement user registration logic here
};

function P_Signup() {
  return (
    <DefaultLayout>
      <div className="max-w-md mx-auto p-10 local-theme-bg-md local-theme-border-md shadow-md rounded-md">
        <h2 className="text-2xl font-bold mb-3 local-theme-text-md text-center">
          Create an Account
        </h2>
        <div className="local-theme-text-sm text-center pb-6 text-sm w-4/5 mx-auto">
          Create your account to explore opportunities, collaborate on projects,
          and stay connected.
        </div>

        <Form
          enableReinitialize={true}
          initialValues={initialValues}
          validationSchema={validations}
          onSubmit={onSubmit}
        >
          <div className="flex flex-col gap-4">
            <div className="grid grid-cols-2 gap-4">
              <Input type="text" name="firstName" placeholder="First Name" />
              <Input type="text" name="lastName" placeholder="Last Name" />
            </div>
            <Input type="email" name="email" placeholder="Your Email" />
            <Input
              type="password"
              name="password"
              placeholder="Your Password"
            />
            <Input
              type="password"
              name="confirmPassword"
              placeholder="Confirm Password"
            />
            <Button
              type="submit"
              text="Sign Up"
              variant="success"
              size="lg"
              shape="softRoundedSquare"
              block
            />
          </div>
        </Form>

        <div className="text-center text-gray-500 my-4">Or</div>

        {/* Social Signup Buttons */}
        <div className="flex flex-col gap-3">
          <Button
            text="Sign up with Google"
            icon={<FaGoogle />}
            variant="default"
            size="lg"
            shape="softRoundedSquare"
            block
            onClick={handleGoogleSignup}
          />
          <Button
            text="Sign up with LinkedIn"
            icon={<FaLinkedin />}
            variant="default"
            size="lg"
            shape="softRoundedSquare"
            block
            onClick={handleLinkedInSignup}
          />
        </div>

        <div className="text-center text-sm mt-4">
          Already have an account?{" "}
          <a href="/login" className="text-blue-600">
            Log in
          </a>
        </div>
      </div>
    </DefaultLayout>
  );
}

export default P_Signup;
